import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import './i18n/i18n'

import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

import { GlobalStyles } from './components'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { store } from './app/store'
import { QueryClient, QueryClientProvider } from 'react-query'

const container = document.getElementById('root')!
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: false }
  }
})
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <GlobalStyles>
          <App />
        </GlobalStyles>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
